export const getEnvVariables = () => {
    return {
        MODE: process.env.REACT_APP_CLIENT_ID,
        API_URL: process.env.REACT_APP_BASE_URL,
        SATISFACTION_SURVEY: process.env.REACT_APP_SATISFACTION_SURVEY,
        VERIFICATION_SURVEY: process.env.REACT_APP_SURVEY_VERIFICATION,
        SURVEY: process.env.REACT_APP_SURVEY
    };
};
